export const environment = {
  production: process.env.NODE_ENV === "production",
  useLocalStorage: process.env.REACT_APP_USE_LOCAL_STORAGE === "true",
  appPreferencesPrefix: process.env.REACT_APP_PREFERENCES_PREFIX || "ts:admin:",
  authApiBaseUrl:
    process.env.REACT_APP_AUTH_API_BASE_URL || "http://localhost:7001",
  userApiBaseUrl:
    process.env.REACT_APP_USER_API_BASE_URL || "http://localhost:7002",
  adminApiBaseUrl:
    process.env.REACT_APP_ADMIN_API_BASE_URL || "http://localhost:7003",
  devoteeApiUrl:
    process.env.REACT_APP_DEVOTEE_API_BASE_URL || "http://localhost:7004",
  // L1: the AES encryption key was removed. It was compiled into this bundle,
  // so it was readable by anyone and protected nothing. The browser no longer
  // encrypts anything - TLS covers transit, bcrypt covers storage.
  defaultDevoteeTrialPeriod:
    process.env.REACT_APP_DEFAULT_DEVOTEE_TRIAL_PERIOD || 3,
  skipLoaderRoutes: [
    "/api/v1/auth/health",
    "/api/v1/admin/locations/activities",
    "/api/v1/admin/locations/states",
    "/api/v1/admin/locations/districts/:state_id",
  ],
  footerHiddenRoutes: ["/login", "/reset-password", "/forget-password"],
};
